module.exports = __webpack_public_path__ + "img/96.1c367400.png";